import React, { useEffect, useState, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import get from 'lodash/get';
import qs from 'query-string';
import FilterBar from '../component/FilterBar';
import getCampaignWidgets from '../../../actions/getCampaignWidgets';
import { filter } from '../actions/actionTypes';
import ROUTES from '../../../AppRoutes/RouteConstants';
import preProcessOptions from '../utils/preProcessOptions';
import { normalize, updateFilterValues } from '../utils/queryParams';
import { fetchDataWithAppliedFilters } from '../utils/fetchData';
import { View } from '../../../components/Common/react-native-components';
import { parseQueryParams } from '../utils/queryParams';
import { sections } from '../constants/sectionConstants';

const FilterBarContainer = ({ dispatch, activeHotelId, filterSlice }) => {
  const location = useLocation();
  const history = useHistory();

  const [localFilters, setLocalFilters] = useState({});
  const [open, setOpen] = useState(false);
  const applied_filters = get(filterSlice, 'applied_filters', {});
  const showLoading = filterSlice.filtersLoading;

  const getCurrentSection = pathname => {
    if (pathname.endsWith(ROUTES.OVERVIEW)) return sections.OVERVIEW;
    if (pathname.endsWith(ROUTES.ONLINE_REVIEW)) return sections.ONLINE_REVIEW;
    if (pathname.endsWith(ROUTES.FEEDBACK)) return sections.FEEDBACK;
    if (pathname.endsWith(ROUTES.AI_INSIGHTS)) return sections.AI_INSIGHTS;
    return 'default';
  };
  const currentSection = useMemo(() => {
    return getCurrentSection(location.pathname);
  }, [location.pathname]);

  const handleConfig = filtersConfig => {
    const queryFilters = parseQueryParams(location.search);
    const applied_filter_values = filterSlice.applied_filter_values;

    const hasQueryFilters = queryFilters && Object.keys(queryFilters).length > 0;

    const activeFilters = hasQueryFilters ? queryFilters : {};
    let defaultFilters = {};

    filtersConfig.forEach(filter => {
      const { key, defaultValue } = filter;

      if (activeFilters[key]) {
        defaultFilters[key] = activeFilters[key];
      } else if (applied_filter_values[key]) {
        defaultFilters[key] = applied_filter_values[key];
      } else if (defaultValue) {
        defaultFilters[key] = [defaultValue];
      }
    });
    defaultFilters = { ...defaultFilters };
    dispatch({
      type: filter.SET_APPLIED_FILTER_VALUES,
      payload: { applied_filter_values: defaultFilters }
    });
    dispatch(fetchDataWithAppliedFilters(defaultFilters, currentSection));
    defaultFilters = updateFilterValues(defaultFilters, filtersConfig);

    dispatch({
      type: filter.SET_APPLIED_FILTERS,
      payload: { applied_filters: defaultFilters }
    });

    setLocalFilters(defaultFilters);
  };

  useEffect(() => {
    const config = filterSlice.config?.[currentSection];
    if (!config) return;

    const queryFilters = parseQueryParams(location.search);

    const filtersWithLabel = updateFilterValues(queryFilters, config);

    dispatch({
      type: filter.SET_APPLIED_FILTERS,
      payload: { applied_filters: filtersWithLabel }
    });

    dispatch({
      type: filter.SET_APPLIED_FILTER_VALUES,
      payload: { applied_filter_values: queryFilters }
    });

    setLocalFilters(filtersWithLabel);
  }, [location.search, filterSlice.config?.[currentSection]]);

  useEffect(() => {
    if (currentSection === 'default') return;
    dispatch({
      type: filter.SET_FILTER_LOADING,
      payload: { loading: true }
    });
    const campaign = currentSection;
    const config = get(filterSlice, `config.${currentSection}`, null);
    if (config) {
      dispatch({
        type: filter.SET_FILTER_LOADING,
        payload: { loading: false }
      });
      handleConfig(config);
      return;
    }
    dispatch(
      getCampaignWidgets({
        activeHotelId,
        campaign,
        pageType: 'filter',
        onSuccess: configResponse => {
          const filtersConfig = get(configResponse, 'widget_list[0].contents.filter_config', {});
          filtersConfig.forEach(filter => {
            filter.options = preProcessOptions(filter.options || []);
          });
          dispatch({
            type: filter.SET_CONFIG,
            payload: { section: currentSection, config: filtersConfig }
          });
          dispatch({
            type: filter.SET_FILTER_LOADING,
            payload: { loading: false }
          });
          handleConfig(filtersConfig);
        },
        onError: error => {
          dispatch({
            type: filter.SET_FILTER_LOADING,
            payload: { loading: false }
          });
          dispatch({
            type: filter.SET_FILTER_ERROR
          });
        }
      })
    );
  }, [currentSection]);

  const handleRun = () => {
    const appliedFilterValues = normalize(localFilters);
    dispatch({
      type: filter.SET_APPLIED_FILTER_VALUES,
      payload: { applied_filter_values: appliedFilterValues }
    });
    const stringified = encodeURIComponent(JSON.stringify(appliedFilterValues));
    const parsedQuery = qs.parse(location.search);
    parsedQuery.filters = stringified;

    const newQuery = qs.stringify(parsedQuery);
    history.push(`${location.pathname}?${newQuery}`);

    dispatch({
      type: filter.SET_APPLIED_FILTERS,
      payload: { applied_filters: localFilters }
    });
    dispatch(fetchDataWithAppliedFilters(appliedFilterValues, currentSection));
    setOpen(false);
  };
  if (currentSection === 'default') {
    return <></>;
  }
  return (
    <View style={!open && { position: 'sticky', zIndex: 1000, top: 76 }}>
      <FilterBar
        filters={localFilters}
        appliedFilters={applied_filters}
        onFiltersChange={setLocalFilters}
        onRun={handleRun}
        showLoading={showLoading}
        config={get(filterSlice, `config.${currentSection}`, [])}
        open={open}
        setOpen={setOpen}
      />
    </View>
  );
};

const mapStateToProps = state => ({
  activeHotelId: state.app?.active_hotel_id,
  language: state.app?.language,
  allMessageFetched: state.app?.allMessageFetched,
  filterSlice: state.filterReducer
});

export default connect(mapStateToProps)(FilterBarContainer);
